module.exports = __webpack_public_path__ + "static/img/system_2.16da19ba.svg";